import React, { useState, useEffect } from "react";
import RoleToggle from "../../components/RoleToggle";
import UnifiedManifestTab from "./_components/UnifiedManifestTab";
import LocationTab from "../PickupManagement/_components/LocationTab";
import { usePermission } from "../../hooks/usePermissionTabs";

const ManifestManagement: React.FC = () => {
  const { allowed: canReadPickup } = usePermission("pickup_manifests", "read");
  const { allowed: canReadReturn } = usePermission("return_to_shipper", "read");
  const { allowed: canReadProduct } = usePermission("product_manifest", "read");
  const { allowed: canReadLocation } = usePermission("pickup_locations", "read");

  const visibleTabs = [
    ...(canReadPickup || canReadReturn || canReadProduct ? ["All Manifests"] : []),
    ...(canReadLocation ? ["Pickup Locations"] : []),
  ];

  const [activeTab, setActiveTab] = useState("");
  const [mainHeaderButtons, setMainHeaderButtons] = useState<React.ReactNode>(null);

  useEffect(() => {
    if (visibleTabs.length > 0 && !visibleTabs.includes(activeTab)) {
      setActiveTab(visibleTabs[0]);
    }
  }, [visibleTabs, activeTab]);

  if (visibleTabs.length === 0) {
    return (
      <div className="p-6 text-center text-gray-500">
        You don't have access to this section
      </div>
    );
  }

  return (
    <div className="px-4 space-y-2" style={{ fontFamily: '"Inter Tight", sans-serif' }}>
      {/* Title & Tabs row — matches admin PermissionTabManager layout */}
      <div className="flex justify-between items-center flex-wrap lg:flex-nowrap w-full  ">
        <div className="flex items-center gap-4 flex-wrap lg:flex-nowrap">
          {visibleTabs.length > 0 && (
            <RoleToggle
              options={visibleTabs}
              active={activeTab}
              onChange={(tab: any) => {
                setActiveTab(tab);
              }}
              containerClassName="inline-flex items-center gap-2.5 rounded-lg bg-gradient-to-b from-white/20 to-white/60 backdrop-blur-xl transition-all duration-300 py-1 px-1.5 overflow-x-auto hide-scrollbar max-w-full shadow-inner border border-gray-300"
              activeClassName="bg-black text-white font-bold shadow-sm"
              inactiveClassName="bg-transparent text-[#212121]/70 font-bold"
            />
          )}
        </div>
        {mainHeaderButtons && (
          <div className="flex items-center gap-2 pr-3">
            {mainHeaderButtons}
          </div>
        )}
      </div>

      {/* Tab content */}
      <div>
        {activeTab === "All Manifests" && (
          <UnifiedManifestTab setHeaderButtons={setMainHeaderButtons} />
        )}
        {activeTab === "Pickup Locations" && (
          <LocationTab setHeaderButtons={setMainHeaderButtons} />
        )}
      </div>
    </div>
  );
};

export default ManifestManagement;
